//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { message } from "ant-design-vue";
import "ant-design-vue/es/message/style/index.css"
import Vue from "vue";

Vue.use(message)
export default {
  name: "Export",
  components: {},
  props: {
    showSource: {
      type: Boolean,
      default: false
    },
    showExport: {
      type: Boolean,
      default: true
    },
    sourceUrl: {
      type: String
    },
    screenId: {
      type: String
    },
    screenName: {
      type: String
    },
    block: {
      type: Boolean,
      default: false
    },
    createScreenShotHandler: {
      type: [Function, null]
    },
    title: {
      type: String
    },
    fileName: {
      type: String
    },
    container: {
      type: [String, Boolean],
      default: 'body'
    }
  },
  methods: {
    doMakeScreenShot() {
      if (this.createScreenShotHandler) {
        return this.createScreenShotHandler()
      } else {
        return this.$store.dispatch('makeScreenshotOfSection', {
          elementId: this.screenId,
          fileName: this.fileName || this.screenName,
          title: this.title,
          store: this.$store
        })
      }
    },
    handleCreateScreen() {
      new Promise((resolve, reject) => {
        message.loading({ content: 'Создаётся скриншот...', key: 'screen' })

        this.doMakeScreenShot()
          .then(() => {
            message.success({ content: 'Готово!', key: 'screen', duration: 2 });
          })
          .catch((error) => {
            console.error(error)
            message.error({ content: 'Произошла ошибка', key: 'screen' })
          })
      })

      this.$emit('make-screenshot');

    }
  }
}
